﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_pictureSingleList from './tpl/pictureSingleList.html';
import View_PictureSingleListItem from './pictureSingleListItem';

export default Marionette.CollectionView.extend({
    tagName: 'ul',
    className: '',
    attributes: function () {
        return {
            id: 'pictureSingleListItem',
            className : 'div100'
        }
    },
    childViewContainer: '#pictureSingleListItem',
    childView: View_PictureSingleListItem,
    getTemplate: function () {
        return tpl_pictureSingleList();
    },
    ui: {
        'pictureSingleListItem': '#pictureSingleListItem'
    },

    initialize: function () {
        this.app = this.options.app;

    },
    buildChildView: function (child, ChildViewClass, childViewOptions) {
        var options = _.extend({ model: child }, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    },
    onAttach() {
    }
});
